import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import {
	DashChartInfo,
	DashReportType,
} from '../../models/organizations.model';
import {
	fetchDashOrgURLsStart,
	setEditingDashOrgURL,
} from '../../state/organizations.actions';
import {
	selectDashChartsUrls,
	selectOrgLoading,
} from '../../state/organizations.selector';

@Component({
	selector: 'app-org-reports',
	styleUrls: ['./org-reports.component.scss'],
	templateUrl: './org-reports.component.html',
})
export class OrgReportsComponent implements OnInit, OnDestroy {
	filter: UntypedFormControl = new UntypedFormControl('all');
	filteredLinks: DashChartInfo[] = [];
	links: DashChartInfo[] | null = null;
	loading$: Observable<boolean>;
	orgId: string = '';

	orgs: { id: string; name: string }[] = [{ id: 'all', name: ' Todas' }];

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly router: Router,
		private readonly store: Store,
	) {
		this.loading$ = this.store.select(selectOrgLoading);
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id }) => {
			this.orgId = id;
		});
		this.store.dispatch(fetchDashOrgURLsStart());
		this.store
			.select(selectDashChartsUrls)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((ch) => {
				if (ch) {
					this.links = [];
					ch.forEach((c) => {
						this.links?.push(c);
						if (this.orgs.findIndex((o) => o.id === c.organization_id) === -1) {
							this.orgs.push({
								id: c.organization_id,
								name: c.organization_name,
							});
						}
					});
					this.links.sort((a, b) =>
						a.organization_name > b.organization_name ? 1 : -1,
					);
					this.filteredLinks = this.links;
					this.orgs.sort((a, b) => (a.name > b.name ? 1 : -1));
				}
			});
	}

	onEditLink(link: DashChartInfo): void {
		this.store.dispatch(setEditingDashOrgURL({ link }));
		this.router.navigate(['organizacoes', this.orgId, 'painel', 'link']);
	}

	onFilterChange(orgId: string): void {
		if (orgId === 'all') {
			this.filteredLinks = this.links!;
		} else {
			this.filteredLinks = this.links!.filter(
				(l) => l.organization_id === orgId,
			);
		}
	}

	processChartType(t: DashReportType): string {
		switch (t) {
			case 'HEALTH':
				return 'Saúde';
			case 'SPECIALITY':
				return 'Especialidades';
			case 'REASON':
				return 'Motivos';
			default:
				return '';
		}
	}
}
